export default __webpack_public_path__ + "static/media/logo-mini.f5c97431.png";